import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { graphql } from 'gatsby';
import SingleWpContentTemplate from '../SingleWpContentTemplate';
import * as loadjs from 'loadjs';
const SinglePodcastTemplate = ({ data, pageContext }) => {
  console.log(pageContext);
  const extractscript = /<script(.+)<\/script>/gi.exec(data.wpPodcast.content);

  if (extractscript) {
    data.wpPodcast.content = data.wpPodcast.content.replace(
      extractscript[0],
      '',
    );
  }

  useEffect(() => {
    if (extractscript) {
      setTimeout(() => {
        var div = document.createElement('div');
        div.innerHTML = extractscript[0].trim();
        loadjs(div.firstChild.src);
      }, 2000);
    }
  }, data);

  return (
    <SingleWpContentTemplate
      podcast={data.wpPodcast}
      previousItem={pageContext?.previousItem?.node}
      nextItem={pageContext?.nextItem?.node}
      latestBlogposts={pageContext?.latestBlogposts}
      latestPodcasts={pageContext?.latestPodcasts}
      relatedPosts={pageContext?.relatedPosts?.map(postNode => postNode.node)}
      isPodcast={true}
    />
  );
};

SinglePodcastTemplate.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default SinglePodcastTemplate;

export const postQuery = graphql`
  query($id: String!) {
    wpPodcast(id: { eq: $id }) {
      content
      date(formatString: "MMM DD, YYYY")
      modified(formatString: "MMM DD, YYYY")
      seo {
        canonical
        metaDesc
        focuskw
        metaKeywords
        title
      }
      title
      date(formatString: "MMM DD, YYYY")
      slug
      desiredSlug
      tags {
        nodes {
          slug
          name
        }
      }
      featuredImage {
        node {
          mediaItemUrl
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
            }
          }
        }
      }
      status
      categories {
        nodes {
          name
          slug
          id
        }
      }
    }
  }
`;
